import { useState, useEffect } from "react";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useNavigate } from "react-router-dom";
import { useRecommendHall } from "./../../../utils/hooks/useRecommendHall";
import { setWeddingRegion } from "@src/@slice/recommendHallSlice";
import toast from "@src/utils/toast";
import BottomFixedModal from "@src/components/common/bottomFixedModal/BottomFixedModal";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import StopRecommend from "./_component/StopRecommend";

const region = {
  서울: [
    "강남/서초",
    "영등포/구로",
    "종로/용산/중구",
    "강서/양천/마포/은평/서대문",
    "강동/송파",
    "관악/동작/금천",
    "광진/성동",
    "성북/동대문/중랑/노원/강북/도봉",
  ],
  경기: [
    "수원/용인",
    "부천",
    "성남",
    "광명/안산/안양/의왕/시흥",
    "고양/파주",
    "의정부/양주/포천",
    "구리/남양주/하남/광주",
    "평택/이천",
  ],
  인천: ["인천 전체"],
  주요지역: ["대전", "대구", "광주"],
};

type TMainRegion = keyof typeof region;

const Region = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  const [showStopModal, setShowStopModal] = useState(false);
  const [selected, setSelected] = useState<string[]>([]);
  const [mainRegion, setMainRegion] = useState<TMainRegion | "">("");
  const [subRegion, setSubRegion] = useState("");

  const [showMainRegionModal, setShowMainRegionModal] = useState<boolean>(false);
  const [showSubRegionModal, setShowSubRegionModal] = useState<boolean>(false);

  const { hallData, dispatch } = useRecommendHall();

  useEffect(() => {
    if (mainRegion) {
      setSubRegion("");
    }
  }, [mainRegion]);

  useEffect(() => {
    setValidate(hallData.weddingRegions.length > 0);
    setSelected(
      hallData.weddingRegions.map((region) => `${region.mainRegion} - ${region.subRegions}`),
    );
  }, [hallData.weddingRegions]);

  const goNext = () => {
    navigate("/recommend/hall/visitor");
  };

  return (
    <>
      <div className="recommend-hall-page recommend-hall-region">
        <CustomHeader
          goBack={() => navigate("/recommend/hall/type")}
          close={() => setShowStopModal(true)}
        />
        <StopRecommend showStopModal={showStopModal} setShowStopModal={setShowStopModal} />
        <div className="recommend-hall-page-body">
          <PageTitle title={`예식 지역을 선택해 주세요.`} />
          <div className="recommend-hall-region-select-wrap">
            <div className="recommend-hall-region-label">
              <span>지역을 선택해주세요.</span>
              <span>최대 2개 선택</span>
            </div>
            <div
              className="select select-full select-gray"
              onClick={() => setShowMainRegionModal(true)}
            >
              <span>{mainRegion === "" ? "지역을 선택해 주세요." : mainRegion}</span>
            </div>
          </div>
          <div className="recommend-hall-region-select-wrap">
            <div className="recommend-hall-region-label">
              <span>상세 지역을 선택해주세요.</span>
            </div>
            <div
              className={`select select-full select-gray ${mainRegion === "" ? "disabled" : ""}`}
              onClick={() => {
                mainRegion !== "" && setShowSubRegionModal(true);
              }}
            >
              <span>{subRegion === "" ? "상세 지역을 선택해 주세요." : subRegion}</span>
            </div>
          </div>

          {selected.length > 0 && (
            <ul className="recommend-hall-chips">
              {selected.map((sel, idx) => (
                <li key={`region-chip-${idx}`} className="recommend-hall-chips-item">
                  <span>{sel}</span>
                  <button className="btn btn-icon">
                    <i
                      className="icon icon-x-gray500-18"
                      onClick={() =>
                        dispatch(
                          setWeddingRegion({
                            region: {
                              mainRegion: sel.split(" - ")[0],
                              subRegions: sel.split(" - ")[1],
                            },
                          }),
                        )
                      }
                    />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="recommend-hall-page-footer">
          <button
            onClick={goNext}
            className={`btn btn-giant btn-red500 btn-full ${!validate ? "btn-disabled" : ""}`}
            disabled={!validate}
          >
            다음
          </button>
        </div>
      </div>
      <BottomFixedModal
        className="recommend-hall-region-modal-list"
        isShow={showMainRegionModal}
        title={"지역을 선택해주세요."}
        isTransition={true}
        hideModal={() => {
          setShowMainRegionModal(false);
        }}
      >
        <ul>
          {Object.keys(region).map((regionKey) => (
            <li
              key={`main-opt-${regionKey}`}
              className={`${regionKey === mainRegion ? "selected bold" : ""}`}
              onClick={() => {
                setMainRegion(regionKey as TMainRegion);
                setShowMainRegionModal(false);
                setShowSubRegionModal(true);
              }}
            >
              {regionKey}
              {regionKey === mainRegion && (
                <span>
                  <i className="icon icon-checkmark-brown500"></i>
                </span>
              )}
            </li>
          ))}
        </ul>
      </BottomFixedModal>
      <BottomFixedModal
        className="recommend-hall-region-modal-list"
        isShow={showSubRegionModal}
        title={"상세 지역을 선택해주세요."}
        isTransition={true}
        hideModal={() => {
          setShowSubRegionModal(false);
        }}
      >
        <ul>
          {mainRegion &&
            region[mainRegion].map((r, idx) => (
              <li
                key={`sub-opt-${idx}`}
                className={`${r === subRegion ? "selected bold" : ""}`}
                onClick={() => {
                  if (selected.length === 2) {
                    toast.showSnackbar("최대 2개만 선택 가능합니다.", {
                      bottomPosition: 100,
                    });
                  }
                  setSubRegion(r);
                  if (r !== "") {
                    if (selected.length < 2) {
                      setSelected([...selected, `${mainRegion} - ${r}`]);
                      dispatch(
                        setWeddingRegion({
                          region: { mainRegion: mainRegion, subRegions: r },
                        }),
                      );
                    }
                  }
                  setMainRegion("");
                  setSubRegion("");
                  setShowSubRegionModal(false);
                }}
              >
                {r}
                {r === subRegion && (
                  <span>
                    <i className="icon icon-checkmark-brown500"></i>
                  </span>
                )}
              </li>
            ))}
        </ul>

        <div className="recommend-hall-region-modal-list-bottom-btn-wrap">
          <button
            className="btn btn-giant btn-full btn-gray50"
            onClick={() => {
              setSubRegion("");
              setShowSubRegionModal(false);
              setShowMainRegionModal(true);
            }}
          >
            이전
          </button>
        </div>
      </BottomFixedModal>
    </>
  );
};

export default Region;
